export const regionalSKUs = {
    plans: [
      {
        id: 'REGS3-MONTH',
        name: 'Regional Instructor Led Training',
        price: 12900,
        description:
          'Access for up to three students to attend Regional Instructor-Led Training',
        period_unit: 'month',
        product_type: 'ilt',
        status: 'active',
        visibility: 'public',
        seats: 3,
      },
      {
        id: 'REGS6-MONTH',
        name: 'Regional Instructor Led Training',
        price: 16900,
        description:
          'Access for up to six students to attend Regional Instructor-Led Training',
        period_unit: 'month',
        product_type: 'ilt',
        status: 'active',
        visibility: 'public',
        seats: 6,
      },
      {
        id: 'REGS9-MONTH',
        name: 'Regional Instructor Led Training',
        price: 20900,
        description:
          'Access for up to nine students to attend Regional Instructor-Led Training',
        period_unit: 'month',
        product_type: 'ilt',
        status: 'active',
        visibility: 'public',
        seats: 9,
      },
      {
        id: 'ILT4S1-ONETIME',
        name: 'Regional Instructor Led 4-Hour Training One-Time Purchase',
        price: 17500,
        description:
          'Access for one person to attend any 4-hour in-person training event.',
        period_unit: 'onetime',
        product_type: 'ilt',
        class_hours: '4',
        status: 'active',
        visibility: 'public',
        seats: 1,
      },
      {
        id: 'ILT8S1-ONETIME',
        name: 'Regional Instructor Led 8-Hour Training One-Time Purchase',
        price: 32500,
        description:
          'Access for one person to attend any 8-hour in-person training event.',
        period_unit: 'onetime',
        product_type: 'ilt',
        class_hours: '8',
        status: 'active',
        visibility: 'public',
        seats: 1,
      },
    ],
  }